import type { Booking } from '../types/booking';

export interface PaymentAmounts {
  /** Formatted amount string (e.g. "120.00") or undefined when no payment data */
  readonly amountPaid: string | undefined;
  /** Formatted amount string (e.g. "120.00") or undefined when no payment data */
  readonly amountPending: string | undefined;
}

/**
 * Derives display values for the Amount Paid and Amount Pending columns.
 * Returns undefined for both when booking.payment is absent (legacy bookings).
 *
 * Full-capture-only model: the booking total either fully succeeds or does not.
 */
export function derivePaymentAmounts(booking: Booking): PaymentAmounts {
  if (!booking.payment) return { amountPaid: undefined, amountPending: undefined };

  const total = booking.totalPrice; // string, e.g. "120.00"
  const zero  = '0.00';

  switch (booking.payment.status) {
    case 'SUCCEEDED': return { amountPaid: total, amountPending: zero };
    case 'INITIATED':
    case 'FAILED':    return { amountPaid: zero, amountPending: total };
    case 'EXPIRED':   return { amountPaid: zero, amountPending: zero };
    default:          return { amountPaid: zero, amountPending: zero };
  }
}
